import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlNumber } from '../ControlNumber'

import { control } from './control'

/**
 * @param {string} name
 * @param {number} value
 * @param {Object} defaultProps
 */
export function number(name, value = 0, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlNumber, defaultProps)
}
